import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getClientDomain } from "../../utils/functions/client-code";
import { getCurrentTimezoneOffset } from "../../utils/functions/date-time";
import { v4 as uuidv4 } from "uuid";

export const baseUrl = import.meta.env.VITE_SERVER_URL;

export const baseApi = createApi({
  reducerPath: "baseApi",
  baseQuery: fetchBaseQuery({
    baseUrl: baseUrl,
    prepareHeaders: (headers) => {
      const client_code = getClientDomain();
      const requestId = uuidv4();
      if (client_code) {
        headers.set("X-Client-Code", `${client_code}`);
      }
      headers.set("X-Hash-Key", `${requestId}`);
      headers.set("X-Dashboard-Version", "v2");
      headers.set("X-Timezone-Offset", getCurrentTimezoneOffset());
      return headers;
    },
    // headers: {
    //   "ngrok-skip-browser-warning": "true",
    // },
    credentials: "include",
  }),
  tagTypes: [] as string[],
  endpoints: () => ({}),
});

export const { reducer: baseApiReducer, middleware: baseApiMiddleware } =
  baseApi;
